import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ErrorComponent } from 'error-ui';
import { ProductComponentBase } from '../../../ProductComponentBase';

@Component({
  selector: 'ideal-product-specifications',
  imports: [ErrorComponent],
  standalone: true,
  templateUrl: './product-specifications.component.html',
  styleUrls: ['./product-specifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.loading]': 'loading()',
    '[class.no-content]': '!hasContent()',
  },
})
export class ProductSpecificationsComponent extends ProductComponentBase {
  protected readonly specifications = this.productStore.productSpecifications;
  protected readonly specificationItems = computed(() => this.productStore.productSpecifications()?.specifications ?? []);

  protected override computeIsLoading = () => this.specifications.loading;
  protected override computeHasContent = () => computed(() => !!this.specifications.error() || this.specificationItems().length > 0);
}
